import React, { useState } from "react";
// import JS files

// import others files
import { useNavigate } from "react-router-dom";

const NextPrevCard = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="my-4 md:my-0 bg-mygrays-100 rounded-lg p-4 flex flex-col md:flex-row items-center cursor-pointer text-hover-container"
        onClick={() => navigate(`/news-content/${props.id}`)}
      >
        <img src={props.cover} className="rounded-md w-32" />
        <div className="md:mr-4 mt-4 md:mt-0">
          <span className=" block text-xs md:text-xs font-bold leading-7 text-myblacks-200">
            {props.sub_header}
          </span>
          <span className="mt-2 block text-xs md:text-sm font-bold leading-7 text-myblacks-400 text-hover">
            {props.header}
          </span>
        </div>
      </div>
    </>
  );
};

export default NextPrevCard;
